function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {Promise.resolve(value).then(_next, _throw);}}function _asyncToGenerator(fn) {return function () {var self = this,args = arguments;return new Promise(function (resolve, reject) {var gen = fn.apply(self, args);function _next(value) {asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);}function _throw(err) {asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);}_next(undefined);});};}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { getGlobal } from "../compat";


var _useLeftHandedInput = false;
var __firefoxLMBfix = false;


/** 
                              * Contains static utility functions for DOM and viewer events.
                              *
                              * @memberof Autodesk.Viewing
                              * @alias Autodesk.Viewing.EventUtils
                              */
export var EventUtils = /*#__PURE__*/function () {function EventUtils() {_classCallCheck(this, EventUtils);}_createClass(EventUtils, null, [{ key: "isRightClick",
    /**
                                                                                                                                                                    * @param {DOMEvent} event - A browser-triggered event
                                                                                                                                                                    * @returns {boolean} true when the event matches a secondary-button click.
                                                                                                                                                                    *
                                                                                                                                                                    * @alias Autodesk.Viewing.EventUtils#isRightClick
                                                                                                                                                                    */value: function isRightClick(
    event) {
      var _window = getWindowFromEvent(event);
      if (!(event instanceof _window.MouseEvent))
      return false;

      var button = event.button;

      // Check for Firefox spoof: Control+LMB converted to RMB.
      // The "buttons" property in Firefox will include 1 for LMB and 2 for RMB.
      if ("buttons" in event) {
        // For button down the 1 bit will be on indicating LMB.
        // For button up it's off so check the flag to see if we
        // switched the down event.
        if (__firefoxLMBfix && !(event.buttons & 1)) {// Button up?
          __firefoxLMBfix = false;
          button = 0;
        } else if (button === 2 && event.buttons & 1) {
          button = 0; // Convert back to reality.
          __firefoxLMBfix = true;
        }
      }

      var rightButton = _useLeftHandedInput ? 0 : 2;

      return button === rightButton;
    }

    /**
       * @param {DOMEvent} event - A browser-triggered event
       * @returns {boolean} true when the event matches a middle-button mouse click.
       *
       * @alias Autodesk.Viewing.EventUtils#isMiddleClick
       */ }, { key: "isMiddleClick", value: function isMiddleClick(
    event) {
      var _window = getWindowFromEvent(event);
      if (!(event instanceof _window.MouseEvent))
      return false;

      return event.button === 1;
    }

    /**
       * Internally used function to set UX for left-handed users.
       * @param {boolean} value - true to switch left and right buttons.
       *
       * @alias Autodesk.Viewing.EventUtils#setUseLeftHandedInput
       *
       * @private
       */ }, { key: "setUseLeftHandedInput", value: function setUseLeftHandedInput(
    value) {
      _useLeftHandedInput = value;
    }

    /**
       * If there's no camera transition, return immediately.
       * Otherwise, resolve when the camera transition is finished.
       * @param {Autodesk.Viewing.Viewer3D} viewer
       * @alias Autodesk.Viewing.EventUtils#waitUntilTransitionEnded
       */ }, { key: "waitUntilTransitionEnded", value: function () {var _waitUntilTransitionEnded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(
      viewer) {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:if (!(
                !viewer.navigation.getRequestTransition() && !viewer.navigation.getTransitionActive())) {_context.next = 2;break;}return _context.abrupt("return");case 2:return _context.abrupt("return",



                new Promise(function (resolve) {
                  setTimeout(function () {
                    // Try again in case there is a requestTransition, but CAMERA_TRANSITION_COMPLETED didn't get fired.
                    // It can happen in case there is a requestTransition to the same camera position exactly.
                    if (!viewer.navigation.getRequestTransition() && !viewer.navigation.getTransitionActive()) {
                      resolve();
                    } else {
                      viewer.addEventListener(Autodesk.Viewing.CAMERA_TRANSITION_COMPLETED, resolve, { once: true });
                    }
                  });
                }));case 3:case "end":return _context.stop();}}}, _callee);}));function waitUntilTransitionEnded(_x) {return _waitUntilTransitionEnded.apply(this, arguments);}return waitUntilTransitionEnded;}()


    /**
                                                                                                                                                                                                                    * If geometry has been loaded, return immediately.
                                                                                                                                                                                                                    * Otherwise, resolve when the geometry loaded event is fired.
                                                                                                                                                                                                                    * @param {Autodesk.Viewing.Viewer3D} viewer
                                                                                                                                                                                                                    * @param [Autodesk.Viewing.Model] model - Default is viewer.model, if not provided
                                                                                                                                                                                                                    * @alias Autodesk.Viewing.EventUtils#waitUntilGeometryLoaded
                                                                                                                                                                                                                    */ }, { key: "waitUntilGeometryLoaded", value: function () {var _waitUntilGeometryLoaded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(
      viewer) {var model,_args2 = arguments;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:model = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : viewer.model;if (!(
                model && model.isLoadDone())) {_context2.next = 3;break;}return _context2.abrupt("return");case 3:return _context2.abrupt("return",



                new Promise(function (resolve) {
                  var cb = function cb(e) {
                    // In the case where we set this wait very early (before a model is even loaded),
                    // the default model will be null, so in that case just resolve
                    if (!model || model === e.model) {
                      resolve();
                      viewer.removeEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, cb);
                    }
                  };
                  viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, cb);
                }));case 4:case "end":return _context2.stop();}}}, _callee2);}));function waitUntilGeometryLoaded(_x2) {return _waitUntilGeometryLoaded.apply(this, arguments);}return waitUntilGeometryLoaded;}() }]);return EventUtils;}();




/**
                                                                                                                                                                                                                                               * @private
                                                                                                                                                                                                                                               */
function getWindowFromEvent(event) {
  var _document = event.target && event.target.ownerDocument;
  if (_document) {
    return _document.defaultView || _document.parentWindow;
  }
  return getGlobal();
}


// Backwards compatibility - TODO: Remove in v8.0.0
Autodesk.Viewing.isRightClick = EventUtils.isRightClick;
Autodesk.Viewing.isMiddleClick = EventUtils.isMiddleClick;